import { useState } from 'react'
import { Box, Button, Grid, makeStyles, Theme, Typography } from '@material-ui/core'
import { Modal } from 'components'
import { propsAction } from 'store/props'
import { useReduxDispatch, useReduxSelector } from 'hooks'
import { promoContestLoad, promoContestStore } from 'api/promo'
import { QuestionForm } from 'types'
import { questIcons } from '../../assets'
import { str } from '../../../../utils'

export const contestTestModalName = 'ContestTestModal'

const useStyles = makeStyles(({ spacing }: Theme) => ({
  btnType: {
    border: '1px solid #fff',
    '&:active, &:hover': {
      border: '1px solid #FFE4CF!important',
      backgroundColor: '#FFE4CF!important',
    },
    '&:disabled': {
      opacity: '0.5',
    },
  },

  btnAnswer: {
    background: '#FFE4CF',
    width: '100%',
    padding: '20px 30px',
    border: '1px solid #fff',
    textAlign: 'left',
    justifyContent: 'flex-start',
    fontSize: 18,
    fontWeight: 500,
    '&:active, &:hover': {
      border: '1px solid #FFE4CF!important',
      backgroundColor: '#FFE4CF!important',
    },
  },
}))

export const ContestTestModal: React.FC = () => {
  const classes = useStyles()
  const dispatch = useReduxDispatch()
  const { modal } = useReduxSelector((state) => state.props)
  const { show = false, params } = modal[contestTestModalName] || {}
  const { fetchPromoUser } = params || {}
  const [step, setStep] = useState<number>(-1)
  const [question, setQuestion] = useState<QuestionForm[]>([])
  const [answer, setAnswer] = useState<number[]>([])
  const [processed, setProcessed] = useState<boolean>(false)
  const [type, setType] = useState<'dog' | 'cat' | null>()
  const handleClose = () => dispatch(propsAction.modal({ modal: { [contestTestModalName]: { show: false } } }))

  const addAnswer = (t: number) => {
    setProcessed(true)
    setAnswer([...answer, t])

    if (step + 1 >= question.length) {
      dispatch(
        propsAction.alert({
          title: 'Интересный факт',
          message: { alert: [question[step].description] },
          onClose: () => {
            promoContestStore({ answers: [...answer, t] }).then((res) => {
              dispatch(
                propsAction.alert({
                  message: res?.message,
                  onClose: () => {
                    setStep(-1)
                    setProcessed(false)
                    setAnswer([])
                    setType(null)
                    handleClose()
                  },
                })
              )
            })
          },
        })
      )
    } else {
      dispatch(
        propsAction.alert({
          title: 'Интересный факт',
          message: { alert: [question[step].description] },
        })
      )

      setStep(step + 1)
      setProcessed(false)
    }
  }

  const setQuestType = (t: 'dog' | 'cat') => {
    setProcessed(true)
    setType(t)
    promoContestLoad({ type: t }).then((r) => {
      setQuestion(r.data)
      setProcessed(false)
      setStep(step + 1)
    })
  }

  return (
    <Modal open={show} maxWidth="sm" name={contestTestModalName} onCloseDialog={handleClose}>
      <Box pb={3}>
        <Grid container justifyContent="center">
          <Grid item xs={11}>
            <Box style={{ marginTop: -40 }}>
              Вопрос {step + 2} / {question.length === 0 ? 15 : question.length + 1}
            </Box>
          </Grid>
          <Grid item xs={11}>
            <Typography variant="h2" style={{ fontSize: 24, marginTop: 10 }}>
              {str.normalize(step === -1 ? 'Какой у вас питомец?' : question[step]?.title)}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {step === -1 ? (
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Button onClick={() => setQuestType('cat')} disabled={processed} className={classes.btnType}>
                    <img style={{ maxWidth: '100%' }} src={questIcons?.['qcat.png']} alt="" />
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button onClick={() => setQuestType('dog')} disabled={processed} className={classes.btnType}>
                    <img style={{ maxWidth: '100%' }} src={questIcons?.['qdog.png']} alt="" />
                  </Button>
                </Grid>
              </Grid>
            ) : (
              <Grid container spacing={2}>
                {question[step].answers.map((i) => {
                  return (
                    <Grid key={`ans-${i.id}`} item xs={12}>
                      <Button onClick={() => addAnswer(i.id)} className={classes.btnAnswer} disabled={processed}>
                        {i.title}
                      </Button>
                    </Grid>
                  )
                })}
              </Grid>
            )}
          </Grid>
        </Grid>
      </Box>
    </Modal>
  )
}
